module.exports = __webpack_public_path__ + "img/45f17288c63a420e95c867272723d28f-640.c238770d.jpg";